import { RootState } from 'store/rootReducer';

export const NotFoundErrorPageContentSelector = (state: RootState) => state.content.notFoundErrorPage;
